import * as angular from "angular";
import { support } from "jquery";

let SupportArticlesComponent = {
    selector: "vcSupportArticles",
    templateUrl: "/angular/components/campaign/support-articles.component.html",
    bindings: {
        page: "=",
    },
    controller: class SupportArticlesComponentController {
        // * bindings for typescript compiler *
        public page: number;
        // ************************************

        public step: number = 1;

        public setupSteps = [
            [
                {
                    title: "How to Invite Your Team",
                    subtext: "Getting your team up and running",
                    link: "https://ecanvasser.wistia.com/medias/7unzurriw7",
                },
                {
                    title: "Users and Teams",
                    subtext:
                        "Create and manage individual users, volunteers, reps, and teams",
                    link: "https://support.ecanvasser.com/en/articles/1001117-users-and-teams",
                },
                {
                    title: "Joining via Email",
                    subtext: "How to access Ecanvasser via an email invitation",
                    link: "https://support.ecanvasser.com/en/articles/1003856-joining-by-email",
                },
            ],
            [
                {
                    title: "Team Management Guide",
                    subtext:
                        "How to effectively manage your teams in the Ecanvasser dashboard",
                    link: "https://support.ecanvasser.com/en/articles/1365253-team-management",
                },
                {
                    title: "Users and Teams",
                    subtext:
                        "Create and manage individual users, volunteers, and teams",
                    link: "https://support.ecanvasser.com/en/articles/1001117-users-and-teams",
                },
                {
                    title: "Joining via Email",
                    subtext: "How to access Ecanvasser via an email invitation",
                    link: "https://support.ecanvasser.com/en/articles/1003856-joining-by-email",
                },
            ],
            [
                {
                    title: "Building a Database",
                    subtext:
                        "Learn how to build a contact database from scratch",
                    link: "https://support.ecanvasser.com/en/articles/1268615-how-to-build-a-database-from-scratch",
                },
                {
                    title: "Sourcing a Contact List",
                    subtext:
                        "How to source or build contact lists for your business",
                    link: "https://support.ecanvasser.com/en/articles/1044796-sourcing-your-contact-database",
                },
                {
                    title: "Fixing Import Errors",
                    subtext:
                        "Troubleshoot common errors with contact data imports",
                    link: "https://support.ecanvasser.com/en/articles/2193857-troubleshooting-your-data-import",
                },
            ],
            [
                {
                    title: "Web App Overview",
                    subtext: "Web App Overview subtext needed",
                    link: "https://support.ecanvasser.com/en/articles/4614961-navigating-around-your-web-application",
                },
                {
                    title: "Quick Start Guide",
                    subtext:
                        "Everything you need to know to get the most out of Ecanvasser",
                    link: "https://support.ecanvasser.com/en/articles/1000121-your-quick-start-guide-to-ecanvasser",
                },
                {
                    title: "Mobile App Features",
                    subtext:
                        "Learn the basics of using the Ecanvasser Walk App",
                    link: "https://support.ecanvasser.com/en/articles/5145763-walk-app-navigating-around-the-app",
                },
            ],
            [
                {
                    title: "Managing Lists from Maps",
                    subtext: "How to manage your walk lists effectively",
                    link: "https://support.ecanvasser.com/en/articles/5898664-how-to-assign-lists-manage-territories",
                },
                {
                    title: "Assigning Turfs",
                    subtext:
                        "Learn the ins and outs of assigning turf to team members",
                    link: "https://support.ecanvasser.com/en/articles/1006593-map-page-creating-lists-and-cutting-your-turf",
                },
                {
                    title: "Tracking Progress in Maps",
                    subtext: "How to view real-time progress in the field",
                    link: "https://support.ecanvasser.com/en/articles/4560852-field-tracking",
                },
            ],
            [
                {
                    title: "Customizing Interaction Workflows",
                    subtext:
                        "How to configure and customize interactions to fit your needs",
                    link: "https://support.ecanvasser.com/en/articles/2640816-interaction-statuses",
                },
                {
                    title: "Best Practices for Managing Interactions",
                    subtext: "Get the most out of your interaction workflows",
                    link: "https://support.ecanvasser.com/en/articles/11137791-best-practices-for-managing-interactions",
                },
                {
                    title: "How to Use Interaction Reports",
                    subtext:
                        "Learn how to find and understand interaction data",
                    link: "https://support.ecanvasser.com/en/articles/11137798-how-to-use-interaction-reports",
                },
            ],
            [
                {
                    title: "Field Tracking Guide",
                    subtext:
                        "Learn the ins and outs of field tracking with Ecanvasser",
                    link: "https://support.ecanvasser.com/en/articles/4560852-field-tracking",
                },
                {
                    title: "GPS Troubleshooting",
                    subtext: "Learn how to resolve common GPS issues",
                    link: "https://support.ecanvasser.com/en/articles/11137853-learn-how-to-resolve-common-gps-issues",
                },
                {
                    title: "Activity Log Management",
                    subtext:
                        "How to easily monitor and manage team activity in the field",
                    link: "https://support.ecanvasser.com/en/articles/11137883-user-activity-log-management",
                },
            ],
            [
                {
                    title: "Best Practices for Customization",
                    subtext:
                        "Learn the ins and outs of customizing your canvassing app",
                    link: "https://support.ecanvasser.com/en/articles/11137946-best-practices-for-customization",
                },
                {
                    title: "Managing User Preferences",
                    subtext:
                        "How to manage what users can and can’t do in the app",
                    link: "https://support.ecanvasser.com/en/articles/11137988-managing-what-users-can-and-can-t-do-in-ecanvasser",
                },
                {
                    title: "Testing Your Custom Setup",
                    subtext:
                        "Learn how to test and troubleshoot your customizations",
                    link: "https://support.ecanvasser.com/en/articles/11137946-best-practices-for-customization#h_5af77b0ca3",
                },
            ],
        ];

        public steps: any;
        private $scope: any;

        constructor($scope: any) {
            this.$scope = $scope;
        }

        $onInit() {
            let page = this.page ?? 1;
            this.setSteps(page);

            this.$scope.$watch(
                () => this.page,
                (newValue, oldValue) => {
                    if (!!newValue && newValue != oldValue) {
                        this.setSteps(newValue);
                    }
                },
                true
            );
        }

        setSteps(page: number): void {
            this.steps = this.setupSteps[page - 1];
        }
    },
};

angular
    .module("campaign")
    .component(SupportArticlesComponent.selector, SupportArticlesComponent);
